import React from "react";
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import PropTypes from "prop-types";
import * as _roles from "./roles";

const Authorization = (WrappedComponent, allowedRoles, redirect) => {
  class HOC extends React.Component {
    constructor(props) {
      super(props);
    }

    render() {
      const roles  = _roles.RolesfromToken(this.props.oidc.user.access_token);
      if (allowedRoles.some((allowed) => roles.includes(allowed))) {
        return <WrappedComponent {...this.props} />;
      } else if (!allowedRoles.some((allowed) => roles.includes(allowed)) && redirect != null) {
        browserHistory.push(
          `${global.applicationPath}/${redirect}`
        );
        return null;
      } else {
        return <h1>Don't have permission to access this page</h1>;
      }
    }
  }

  HOC.propTypes = {
    oidc: PropTypes.object.isRequired,
  };

  function mapStateToProps(state) {
    return {
      oidc: state.oidc,
    };
  }

  return connect(mapStateToProps, null)(HOC);
};

export default Authorization;



// WEBPACK FOOTER //
// ./src/authorization/authorization.js